import http from "./http-common";

class PaymentService {
  queryString(payload) {
    return Object.keys(payload)
      .map((key) => key + "=" + payload[key])
      .join("&");
  }
  PhonepeTransaction(data) {
    return http.post(`phonepeTransaction/`, data);
  }
  BillingTransaction(data) {
    return http.post(`billingTransaction/`, data);
  }
  getTransactionStatus(payload) {
    var queryString = this.queryString(payload);
    return http.get(`phonePeResponse1/paymentRedirectDetails?${queryString}`);
  }
  getBillingTransaction(payload) {
    var queryString = this.queryString(payload);
    return http.get(`billingTransaction/list/filter?${queryString}`);
  }

  getBillingCount(payload) {
    var queryString = this.queryString(payload);
    return http.get(
      `/billingTransaction/getBillingTransactionCountStatus?${queryString}`
    );
  }

  initiatePayment(payload){
    return http.post('/phonePeResponse1/phonepe/payment-initiate',payload);
  }
}
export default new PaymentService();
